{{ record[column.field] | date: 'dd/MM/yyyy' }}
